// extracted by mini-css-extract-plugin
module.exports = {"altHero":"Yl","altProd":"Zl","subheading":"_l","subtext":"am","extrainfo":"bm","copy":"cm","cta":"dm","disabled":"em"};